<template>
  <CpfForm
    v-model="identifier"
    :login-type="loginType"
    @on-submit="submit"
    @toggle-login-type="toggleLoginType"
    ref="form"
  />
</template>

<script>
import { mapActions } from 'vuex'

const CpfForm = () => import('@/modules/Login/CpfForm')

export default {
  components: {
    CpfForm
  },
  computed: {
    identifier: {
      get() {
        return this.$store.state.authentication.loginType === 'cpf'
          ? this.$store.state.authentication.cpf
          : this.$store.state.authentication.identifier
      },
      set(value) {
        if (this.$store.state.authentication.loginType === 'cpf') {
          this.$store.commit('authentication/SET_CPF', value)
        } else {
          this.$store.commit('authentication/SET_IDENTIFIER', value)
        }
      }
    },
    loginType() {
      return this.$store.state.authentication.loginType
    }
  },
  methods: {
    ...mapActions('authentication', ['searchCpf', 'searchIdentifier']),

    toggleLoginType() {
      const newType = this.loginType === 'cpf' ? 'email' : 'cpf'
      this.$store.commit('authentication/SET_LOGIN_TYPE', newType)
      // Limpa o campo ao alternar
      this.$store.commit('authentication/SET_CPF', '')
      this.$store.commit('authentication/SET_IDENTIFIER', '')
    },

    async submit() {
      if (!this.$refs.form.validate()) return

      this.$showLoading()

      let status, novoAcesso

      if (this.loginType === 'cpf') {
        const result = await this.searchCpf()
        status = result.status
        novoAcesso = result.novoAcesso
      } else {
        const result = await this.searchIdentifier()
        status = result.status
        novoAcesso = result.novoAcesso
      }

      this.$hideLoading()

      const queryParams = { ...this.$route.query }

      if (status === 200 && !novoAcesso) {
        this.$router.push({ name: 'Senha', query: queryParams })
      } else if (status === 200 && novoAcesso) {
        queryParams.novoAcesso = true
        this.$router.push({ name: 'Senha', query: queryParams })
      } else if (status === 404) {
        const errorMessage = this.loginType === 'cpf' ? 'CPF não encontrado' : 'E-mail não encontrado'
        this.$showErrorMessage(errorMessage)
      }
    }
  }
}
</script>
